<template>
  <v-text-field
    outlined
    clearable
    hide-details
    maxlength="5"
    :label="label"
    v-bind="$attrs"
    @blur="onBlur"
    v-mask="'##:##'"
    autocomplete="off"
    @click:append-outer="$emit('click:append-outer')"
    v-model="localValue"/>
</template>

<script>
export default {
  props: {
    value: String,
    label: {
      type: String,
      default: 'Hora',
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
};
</script>
